import { generateCarleadCreationConfig } from '@wkda/funnel-utils';

function getSuccessRedirectUrl() {
  const env = typeof window === 'undefined' ? process.env.ENV : window['__ENV'];

  return env === 'prod' || env === 'preprod'
    ? '/self-inspection/fr-be-generic/{hash}/'
    : '/self-inspection/fr-be-generic/__fe-3451-be-fr-noimage/{hash}/';
}

const config = generateCarleadCreationConfig({
  locale: 'fr-BE',
  emailSuggestionEnabled: true,
  bookingUrl: '/valeur/15-0/booking',
  confirmationUrl: '/valeur/15-0/booking/confirmed',
  redirectOnSuccessUrl: getSuccessRedirectUrl(),
  featuresFlags: {
    postalCode: true,
    redirectToSelfEvaluation: true,
    affiliateScenario: 'affiliate',
  },
  isPartnerFunnel: true,
  abExperiment: { experimentSnippetName: null },
});

export default config;
